import api from './api';

export default {
  auth: {
    loginStatus() {
      return api.get('/auth/loginStatus');
    },
  },
  proxy: {
    markerSetListByCurrentUser() {
      return api.post('/proxy/function/markerSetListByCurrentUser');
    },
    markerListPageLoad(data) {
      return api.post('/proxy/function/markerListPageLoad', data);
    },
    batchdownloadfile(data) {
      return api.post('/proxy/batchdownloadfile', data);
    },
    uploadfile(data, config) {
      return api.post('/proxy/uploadfile', data, config);
    },
    markerSetAdd(data) {
      return api.post('/proxy/function/markerSetAdd', data);
    },
    markerSetUpdate(data) {
      return api.post('/proxy/function/markerSetUpdate', data);
    },
    markerSetDelete(data) {
      return api.post('/proxy/function/markerSetDelete', data);
    },
    async markerListUpdate(data) {
      const { addList, updList, delList } = data;
      const temp = {};

      const respTotal = {
        data: {
          data: {
            resp_data: {
              add: [],
              del: [],
              upd: [],
              lastModifyTime: '',
            },
          },
        },
      };

      // 拆分 addList，最多一次添加 10 条，避免并发超限
      for (let i = 0; i < addList.length; i + 10) {
        const howmany = addList.length >= 10 ? 10 : addList.length;
        temp.addList = addList.splice(0, howmany);
        temp.delList = [];
        temp.updList = [];
        // eslint-disable-next-line no-await-in-loop
        const res = await api.post('/proxy/function/markerListUpdate', temp);
        // 否则，积累结果
        const respData = JSON.parse(res.data.data.resp_data);
        respTotal.data.data.resp_data.add = respTotal.data.data.resp_data.add.concat(respData.add);
        respTotal.data.data.resp_data.lastModifyTime = respData.lastModifyTime;
      }

      // 拆分 updList，最多一次添加 10 条，避免并发超限
      for (let i = 0; i < updList.length; i + 10) {
        const howmany = updList.length >= 10 ? 10 : updList.length;
        temp.updList = updList.splice(0, howmany);
        temp.delList = [];
        temp.addList = [];
        // eslint-disable-next-line no-await-in-loop
        const res = await api.post('/proxy/function/markerListUpdate', temp);
        // 否则，积累结果
        const respData = JSON.parse(res.data.data.resp_data);
        respTotal.data.data.resp_data.upd = respTotal.data.data.resp_data.upd.concat(respData.upd);
        respTotal.data.data.resp_data.lastModifyTime = respData.lastModifyTime;
      }

      // 额外处理 delList 处理
      if (delList.length) {
        temp.addList = [];
        temp.updList = [];
        temp.delList = delList;
        const res = await api.post('/proxy/function/markerListUpdate', temp);
        // 否则，积累结果
        const respData = JSON.parse(res.data.data.resp_data);
        respTotal.data.data.resp_data.del = respTotal.data.data.resp_data.upd.concat(respData.del);
        respTotal.data.data.resp_data.lastModifyTime = respData.lastModifyTime;
      }

      return respTotal;
    },
    // 加载面标记数据
    markerPolygonPageLoad(data) {
      return api.post('/proxy/function/markerPolygonPageLoad', data);
    },
    // 保存面标记（增/改/删）
    async markerPolygonUpdate(data) {
      const { addList, updList, delList } = data;
      const temp = {};

      const respTotal = {
        data: {
          data: {
            resp_data: {
              add: [],
              del: [],
              upd: [],
            },
          },
        },
      };

      // 拆分 addList，最多一次添加 10 条
      for (let i = 0; i < addList.length; i + 10) {
        const howmany = addList.length >= 10 ? 10 : addList.length;
        temp.addList = addList.splice(0, howmany);
        temp.delList = [];
        temp.updList = [];
        // eslint-disable-next-line no-await-in-loop
        const res = await api.post('/proxy/function/markerPolygonUpdate', temp);
        const respData = JSON.parse(res.data.data.resp_data);
        respTotal.data.data.resp_data.add = respTotal.data.data.resp_data.add.concat(respData.add);
      }

      // 拆分 updList
      for (let i = 0; i < updList.length; i + 10) {
        const howmany = updList.length >= 10 ? 10 : updList.length;
        temp.updList = updList.splice(0, howmany);
        temp.delList = [];
        temp.addList = [];
        // eslint-disable-next-line no-await-in-loop
        const res = await api.post('/proxy/function/markerPolygonUpdate', temp);
        const respData = JSON.parse(res.data.data.resp_data);
        respTotal.data.data.resp_data.upd = respTotal.data.data.resp_data.upd.concat(respData.upd);
      }

      // 处理 delList
      if (delList.length) {
        temp.addList = [];
        temp.updList = [];
        temp.delList = delList;
        const res = await api.post('/proxy/function/markerPolygonUpdate', temp);
        const respData = JSON.parse(res.data.data.resp_data);
        respTotal.data.data.resp_data.del = respData.del;
      }

      return respTotal;
    },
  },
  importAndExport: {
    importFromExcel(data, config) {
      return api.post('/importAndExport/importFromExcel', data, config);
    },
    importFromOmap(data, config) {
      return api.post('/importAndExport/importFromOmap', data, config);
    },
    exportToExcel(params) {
      return api.get('/importAndExport/exportToExcel', {
        params,
        responseType: 'blob',
      });
    },
  },
};
